import React from "react";
import TsPayOnboardingBanner from "./onboardingBanner";
import { FormattedMessage } from "react-intl";
import macImage from "../../../assets/img/mac_landing-ts-pay.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TsPayOnboardingLandingPage = () => {

  const renderCollabText = () => {
    return <b><FormattedMessage id="dashboard.tsPayOnboardingLandingCollabText"/></b>;
  };

  const renderBankText = () => {
    return <b><FormattedMessage id="dashboard.tsPayOnboardingLandingBankText"/></b>;
  };

  const footerBlocksStructure = [
    {
      iconName: "link",
      titleTranslationKey: "dashboard.tsPayOnboardingLandingFooterTitleText1",
      paragraphTranslationKey: "dashboard.tsPayOnboardingLandingFooterP1",
      isSecondChild: false
    },
    {
      iconName: "university",
      titleTranslationKey: "dashboard.tsPayOnboardingLandingFooterTitleText2",
      paragraphTranslationKey: "dashboard.tsPayOnboardingLandingFooterP2",
      isSecondChild: true
    },
    {
      iconName: "tachometer",
      titleTranslationKey: "dashboard.tsPayOnboardingLandingFooterTitleText3",
      paragraphTranslationKey: "dashboard.tsPayOnboardingLandingFooterP3",
      isSecondChild: false
    }
  ];

  const footerBlocks = footerBlocksStructure.map((block, index) => {
    return (
      <div key={index} className="dbx-tspay-onboarding-landing-footer-block">
        <FontAwesomeIcon
          style={{marginBottom: "15px", color: "rgb(21, 41, 53)", fontSize: "28px"}}
          icon={["fal", `${block.iconName}`]}
        />
        <h5 className="dbx-tspay-onboarding-landing-footer-block-text" style={{marginBottom: "25px"}}>
          <FormattedMessage id={`${block.titleTranslationKey}`} />
        </h5>
        <p className="dbx-tspay-onboarding-landing-footer-block-text" style={{fontWeight: "500", fontSize: "13.5px", maxWidth: block.isSecondChild && "316px"}}>
          <FormattedMessage id={`${block.paragraphTranslationKey}`} />
        </p>
      </div>
    );
  });

  return (
    <>
      <TsPayOnboardingBanner isLanding={true} />
      <section className="dbx-tspay-onboarding-landing-body">
			  <div className="dbx-tspay-onboarding-landing-body-block">
			    <img src={macImage} alt="tspay-simulation" />
			  </div>
			  <div className="dbx-tspay-onboarding-landing-body-block">
			    <p className="dbx-tspay-onboarding-landing-body-title">
			      <FormattedMessage id="dashboard.tsPayOnboardingLandingTitle" />
			    </p>
			    <p className="dbx-tspay-onboarding-landing-body-paragraph">
			      <FormattedMessage id="dashboard.tsPayOnboardingLandingP1" values={{collabText: renderCollabText()}}/>
			    </p>
			    <p className="dbx-tspay-onboarding-landing-body-paragraph">
			      <FormattedMessage id="dashboard.tsPayOnboardingLandingP2" />
			    </p>
			    <p className="dbx-tspay-onboarding-landing-body-paragraph">
			      <FormattedMessage id="dashboard.tsPayOnboardingLandingP3" />
			    </p>
			    <p className="dbx-tspay-onboarding-landing-body-paragraph">
			      <FormattedMessage id="dashboard.tsPayOnboardingLandingP4" values={{bankText: renderBankText()}}/>
			    </p>
			  </div>
      </section>

      <footer className="dbx-tspay-onboarding-landing-footer">
			  {footerBlocks}
      </footer>
    </>
  );
};

export default TsPayOnboardingLandingPage;